import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {AbstractContactModel} from '../../models/abstract-contact.model';
import {GtDirectoryService} from '@app/services/gt-directory.service';

@Component({
  selector: 'gt-contact-avatar',
  templateUrl: './contact-avatar.component.html',
  styleUrls: ['./contact-avatar.component.scss']
})
export class ContactAvatarComponent implements OnInit {
  @Input() contact: AbstractContactModel;
  @Input() size = '300px';
  contactImageUrl: SafeUrl;
  status: string;
  fontSize: string;

  constructor(private readonly gtDirectoryService: GtDirectoryService, private readonly sanitizer: DomSanitizer) {}

  ngOnInit() {
    this.contactImageUrl = undefined;

    if (this.contact) {
      this.status = this.contact.status;

      if (this.contact.imageId > -1) {
        this.gtDirectoryService.getContactImage(this.contact.id).subscribe(
          c => {
            const url = `data:image/png;base64,${c.base64image}`;
            this.contactImageUrl = this.sanitizer.bypassSecurityTrustUrl(url);
          },
          error => console.log(`no image with id ${this.contact.id} for ${this.contact.login}`)
        );
      }
    }

    this.fontSize = `${parseInt(this.size, 10) * 0.7}px`;
  }
}
